import styles from './WebinarExperts.module.scss';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const WebinarExperts = ({ props }) => {
  return (
    <section className={classnames(isMobile ? [styles.section, styles.mobile] : [styles.section])}>
      <h2 className={classnames(isMobile ? [styles.sectionTitle, styles.mobile] : [styles.sectionTitle])}>Эксперты</h2>
      <ul className={classnames(isMobile ? [styles.list, styles.mobile] : [styles.list])}>
        {props.map((item) => (
          <li className={styles.item} key={item.id}>
            <div className={styles.image}>
              <img src={item.photo} alt="" />
            </div>
            <p className={classnames(isMobile ? [styles.fio, styles.mobile] : [styles.fio])}>
              <span>{item.lastname}</span> <span>{item.name}</span> <span>{item.secondname}</span>
            </p>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default WebinarExperts;
